import { PageContainer } from '@components/PageContainer';
import { useBankProfile } from '@contexts/BankProfileContext';
import { usePersonalData } from '@hooks/usePersonalData';
import { CompanyDetails, PersonalDetails } from '@pages/settings/profile/components';
import { RoleCard } from '@pages/settings/profile/components/RoleCard';
import { useTranslation } from 'react-i18next';

export const Profile = () => {
	const { t } = useTranslation('', { keyPrefix: 'profile' });
	const { isPersonal } = useBankProfile();
	const { data: personalData, isLoading } = usePersonalData();

	return (
		<PageContainer backUrl={'/settings'} title={t('title')}>
			{!isPersonal && <CompanyDetails />}
			<PersonalDetails isLoading={isLoading} personalData={personalData} />
			{!isPersonal && <RoleCard isLoading={isLoading} role={personalData?.role} />}
		</PageContainer>
	);
};
